export default __webpack_public_path__ + "static/media/menu__content__ads@2x.f69a0d72.png";